/* eslint-disable */
import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { App, AppInfo } from '@capacitor/app';
import { Platform } from '@ionic/angular';
import { forkJoin, Observable, of } from 'rxjs';
import { first, map, switchMap, tap } from 'rxjs/operators';
import { MSRemoteLoggerCategory } from 'src/app/adapters/remote-logger/utils/remote-logger.utils';
import { MigrateServerAddressUseCase } from 'src/app/use-case/migrate-server-address/migrate-server-address.use-case';
import { TranslationUseCase } from 'src/app/use-case/translation/translation.use-case';
import { UserStorageUseCase } from 'src/app/use-case/user-storage/user-storage.use-case';
import { environment } from 'src/environments/environment';
import { PermissionsError, ServerAddressLoadError } from '../../models/error.model';
import { CheckVersionPageModule } from '../../pages/roster/check-version/check-version.module';
import { checkVersionExecuteAsPromise, configExecuteAsPromise } from '../../pages/utils/promise.utils';
import { CheckVersionUseCase } from '../../use-case/ms-api/check-version/check-version.use-case';
import { CheckVersionEvent } from '../../use-case/ms-api/check-version/utils/check-version.utils';
import { GetConfigUseCase } from '../../use-case/ms-api/config/get-config.use-case';
import { RemoteLoggerUseCase } from '../../use-case/remote-logger/remote-logger.use-case';
import { ApiServiceOld } from '../api-old.service';
import { CONSTANTS } from '../config.service';
import { DateTimeService } from '../date-time/date-time.service';
import { GisService } from '../gis.service';
import { PostSignupInitializerService } from '../initializer/post-signup-initializer.service';
import { LoggerService } from '../logger.service';
import { PersonsService } from '../persons.service';
import { PosterService } from '../poster.service';
import { PrefsService } from '../prefs.service';
import { PubSubService } from '../pub-sub.service';
import { SignupSurveyService } from '../signup-survey.service';
import { SqlHelperService } from '../sql-helper.service';
import { BranchService } from '../survey/branch.service';
import { LoadService } from '../survey/load.service';
import { TimeLoggerService } from '../survey/time-logger.service';
import { UtilsService } from '../utils.service';
@Injectable({
  providedIn: 'root'
})
export class RegistrationService {
  constructor(
    private title: Title,
    private platform: Platform,
    private sqlHelper: SqlHelperService,
    private prefs: PrefsService,
    private logger: LoggerService,
    private dateTime: DateTimeService,
    private gis: GisService,
    private translationUseCase: TranslationUseCase,
    private persons: PersonsService,
    private utils: UtilsService,
    private poster: PosterService,
    private signupSurvey: SignupSurveyService,
    private load: LoadService,
    private branch: BranchService,
    private initializer: PostSignupInitializerService,
    private timeLogger: TimeLoggerService,
    private pubSub: PubSubService,
    private configUseCase: GetConfigUseCase,
    private checkVersionUseCase: CheckVersionUseCase,
    private remoteLoggerUseCase: RemoteLoggerUseCase,
    private userStorageUseCase: UserStorageUseCase,
    private migrateServerAddressUseCase: MigrateServerAddressUseCase,
    private apiServiceOld: ApiServiceOld
  ) {}

  afterActivated() {
    const self = this;
    return this.initializer
      .initialize()
      .then(() => this.loadStudy())
      .catch((error) => {
        if (error instanceof PermissionsError) {
          const permissions = error.permissions;
          const permissionsJSON = JSON.stringify(permissions);

          this.logger.error('RegistrationService', MSRemoteLoggerCategory.REGISTRATION_SERVICE, permissionsJSON);
          return ['/permission-error', permissionsJSON];
        } else if (error instanceof ServerAddressLoadError) {
          this.remoteLoggerUseCase.captureException(error);
          return ['/unavailable', 'UNKNOWN'];
        } else {
          this.remoteLoggerUseCase.captureException(error);
          return this.loadStudy();
        }
      });
  }

  loadStudy() {
    this.logger.info('Device details - registration', MSRemoteLoggerCategory.REGISTRATION_SERVICE, {
      width: this.platform.width(),
      height: this.platform.height(),
      platforms: this.platform.platforms()
    })

    // Store the time of activation. We'll use this later to prompt for location services if we haven't seen any trip collection
    return (
      this.prefs
        .getPromise('activatedSeconds')
        // if we haven't stored an activation time, set it this once
        .catch(() => this.prefs.getStorePromise('activatedSeconds', this.dateTime.getNowSeconds()))
        .then(() =>
          Promise.all([
            this.prefs.getPromiseOrDefault(CONSTANTS.longDistanceModeKey),
            this.timeLogger.send()
          ])
        )
        .then((res) => {
          const isLd = res[0];
          CONSTANTS.appInitialized = true;
          let page = '';

          // if ((CONSTANTS.IS_DEVICE === true && CONSTANTS.IS_BROWSERMOVE === true) || (CONSTANTS.IS_DEVICE === false && CONSTANTS.IS_BROWSERMOVE === false)) {
          if (
            environment.production &&
            ((CONSTANTS.IS_DEVICE === true && CONSTANTS.IS_BROWSERMOVE === true) ||
              (CONSTANTS.IS_DEVICE === false && CONSTANTS.IS_BROWSERMOVE === false))
          ) {
            page = 'change-platform';
          } else {
            if (isLd) {
              page = 'trips-ld';
            } else if (CONSTANTS.IS_BROWSERMOVE) {
              page = 'roster';
            } else {
              page = 'dashboard';
            }
          }

          // return { page: page, params: { reactivated: true } };
          return ['/' + page];
        })
        .catch((err) => ['/error'])
    );
  }

  refreshSurveys(authCode, locale, personId) {
    return Promise.resolve(null);
    // if (CONSTANTS.SETTINGS.environment !== 'dev') return Promise.resolve(null);

    // return new Promise(resolve => {
    //     let postData = { authCode: authCode, locale: locale, personId: personId, appVersion: this.appVersion };

    //     this.api.post(CONSTANTS.activatePersonPath, postData)
    //         .subscribe(res => {
    //             return this.prefs.getStorePromise(CONSTANTS.PREF_KEY_SURVEY_RECIPES, res['surveys'])
    //                 .then(() => {
    //                     resolve();
    //                 })
    //         })
    //     })
  }

  getNextPage() {
    return Promise.all([
      this.prefs.getPromises(
        'abortMessageKey',
        'authCode',
        'locale',
        'termsAccepted',
        'personId',
        CONSTANTS.PREF_KEY_SIGNUP_SURVEY_RECIPE,
        'browser',
        'defaultMapLat',
        'defaultMapLon',
        'completedSignup',
        CONSTANTS.longDistanceModeKey
      ),
      this.persons.populated()
    ]).then((results) => {
      const abort = results[0][0];
      const authCode = results[0][1];
      const locale = results[0][2];
      const termsAccepted = results[0][3];
      const personId = results[0][4];
      const hhRecipe = results[0][5];
      const completedSignup = results[0][9];
      const isLd = results[0][10];
      const personsPopulated = results[1];

      CONSTANTS.IS_BROWSERMOVE = results[0][6] === null ? null : Boolean(results[0][6]);
      CONSTANTS.MAPS.DEFAULT_MAP_CENTER = { lat: this.gis.getFloatLatOrLon(results[0][7]), lng: this.gis.getFloatLatOrLon(results[0][8]) };

      this.logger.log('Registration - is device', MSRemoteLoggerCategory.REGISTRATION_SERVICE, CONSTANTS.IS_DEVICE, 'isbMove', CONSTANTS.IS_BROWSERMOVE);
      this.logger.log('Registration - goToNextPage results:', MSRemoteLoggerCategory.REGISTRATION_SERVICE, {
        abort,
        authCode,
        locale,
        termsAccepted,
        personId,
        hhRecipe,
        completedSignup,
        isLd,
        IS_BROWSERMOVE: CONSTANTS.IS_BROWSERMOVE,
        DEFAULT_MAP_CENTER: CONSTANTS.MAPS.DEFAULT_MAP_CENTER
      });

      // Page targets and any nav parameters must be passed back to the component for navigation.
      // Since
      //TODO - list conditions leading to abort
      if (abort) {
        return ['/unavailable', abort.split('.')[1]];
      } else if (!authCode || !completedSignup) {
        return ['/signup'];
      } else if (!locale) {
        return ['/locale'];
        // if using ionic serve, then skip over change-platform
        // otherwise, if they're using the mobile app but should be using the browser, or if they're using the browser but should be using the mobile app
      } else if (
        environment.production &&
        ((CONSTANTS.IS_DEVICE === true && CONSTANTS.IS_BROWSERMOVE === true) ||
          (CONSTANTS.IS_DEVICE === false && CONSTANTS.IS_BROWSERMOVE === false))
      ) {
        // } else if ((CONSTANTS.IS_DEVICE === true && CONSTANTS.IS_BROWSERMOVE === true) || (CONSTANTS.IS_DEVICE === false && CONSTANTS.IS_BROWSERMOVE === false)) {
        return ['/change-platform'];
        // skip license agreement if using web
      } else if (!termsAccepted && CONSTANTS.IS_DEVICE) {
        return ['/terms'];
      } else if (!personsPopulated) {
        if (hhRecipe) {
          return this.load
            .initSignupSurvey()
            .then(() => Promise.all([this.signupSurvey.initialize(), this.timeLogger.initialize()]))
            .then(() => this.signupSurvey.get(null))
            .then((res) => {
              if (res.complete === 1) {
                return ['/persons-setup'];
              } else {
                return this.translationUseCase
                  .setLanguage(locale)
                  .pipe(first())
                  .toPromise()
                  .then(() =>
                    this.branch.goToNextPage(CONSTANTS.surveyTypes.SIGNUP, 'start', this.utils.subset(res, ['id', 'lastPage', 'path']))
                  );
              }
            });
        } else {
          // Need to have hhRecipe before this
          this.logger.error('hhRecipe N/A', MSRemoteLoggerCategory.REGISTRATION_SERVICE);
        }
        // TODO - confirm this is true
        // if signup survey, personId gets sent from server after uploading signup survey (persons-setup page)
        // if not signup survey, we auto set personId if 1 participant, otherwise we need to ask
      } else if (!personId) {
        return this.persons.getParticipants().then((participants) => {
          // if we're in the browser, don't ask who the current user is. just default to the first person
          if (participants.length === 1) {
            return this.setData({ personId: participants[0].idx });
          } else {
            // return { page: 'person', params: {} };
            return ['/person'];
          }
        });
      } else {
        if (
          environment.production &&
          ((CONSTANTS.IS_DEVICE === true && CONSTANTS.IS_BROWSERMOVE === true) ||
            (CONSTANTS.IS_DEVICE === false && CONSTANTS.IS_BROWSERMOVE === false))
        ) {
          return ['/change-platform'];
        } else {
          if (isLd) {
            return ['/trips-ld'];
          } else if (CONSTANTS.IS_BROWSERMOVE) {
            return ['/roster'];
          } else {
            return ['/dashboard'];
          }
        }
      }
    });
  }

  goToNextPage() {
    return Promise.all([
      this.prefs.getPromises(
        'abortMessageKey',
        'authCode',
        'locale',
        'termsAccepted',
        'personId',
        CONSTANTS.PREF_KEY_SIGNUP_SURVEY_RECIPE,
        'browser',
        'defaultMapLat',
        'defaultMapLon',
        'completedSignup'
      ),
      this.persons.populated()
    ]).then(async (results) => {
      const abort = results[0][0];
      const authCode = results[0][1];
      const locale = results[0][2];
      const termsAccepted = results[0][3];
      const personId = results[0][4];
      const hhRecipe = results[0][5];
      const completedSignup = results[0][9];
      const personsPopulated = results[1];

      CONSTANTS.IS_BROWSERMOVE = results[0][6] === null ? null : Boolean(results[0][6]);

      // publish event that browserMove flag is set so survey runner can determine the proper platform
      if (CONSTANTS.IS_BROWSERMOVE !== null) {
        this.pubSub.publish(CONSTANTS.EVENTS.browserMoveFlagSet);
      }

      CONSTANTS.MAPS.DEFAULT_MAP_CENTER = { lat: this.gis.getFloatLatOrLon(results[0][7]), lng: this.gis.getFloatLatOrLon(results[0][8]) };

      this.logger.log('Registration - is device', MSRemoteLoggerCategory.REGISTRATION_SERVICE, CONSTANTS.IS_DEVICE, 'isbMove', CONSTANTS.IS_BROWSERMOVE);
      this.logger.log('Registration - goToNextPage results:', MSRemoteLoggerCategory.REGISTRATION_SERVICE, {
        abort,
        authCode,
        locale,
        termsAccepted,
        personId,
        hhRecipe,
        completedSignup,
        IS_BROWSERMOVE: CONSTANTS.IS_BROWSERMOVE,
        DEFAULT_MAP_CENTER: CONSTANTS.MAPS.DEFAULT_MAP_CENTER
      });

      // Page targets and any nav parameters must be passed back to the component for navigation.
      // Since
      //TODO - list conditions leading to abort
      this.logger.log('goToNextPage', MSRemoteLoggerCategory.REGISTRATION_SERVICE);
      if (abort) {
        return ['/unavailable', abort.split('.')[1]];
      } else if (!authCode || !completedSignup) {
        return ['/signup'];
      } else if (!locale) {
        return ['/locale'];
        // if using ionic serve, then skip over change-platform
        // otherwise, if they're using the mobile app but should be using the browser, or if they're using the browser but should be using the mobile app
      } else if (
        environment.production &&
        ((CONSTANTS.IS_DEVICE === true && CONSTANTS.IS_BROWSERMOVE === true) ||
          (CONSTANTS.IS_DEVICE === false && CONSTANTS.IS_BROWSERMOVE === false))
      ) {
        // } else if ((CONSTANTS.IS_DEVICE === true && CONSTANTS.IS_BROWSERMOVE === true) || (CONSTANTS.IS_DEVICE === false && CONSTANTS.IS_BROWSERMOVE === false)) {
        return this.poster
          .initialize()
          .then(() => this.timeLogger.send())
          .then(() => ['/change-platform']);

        // skip license agreement if using web
      } else if (!termsAccepted && CONSTANTS.IS_DEVICE) {
        return ['/terms'];
      } else if (!personsPopulated) {
        if (hhRecipe) {
          return this.load
            .initSignupSurvey()
            .then(() => Promise.all([this.signupSurvey.initialize(), this.timeLogger.initialize()]))
            .then(() => this.signupSurvey.get(null))
            .then((res) => {
              if (res.complete === 1) {
                return ['/persons-setup'];
              } else {
                return this.translationUseCase
                  .setLanguage(locale)
                  .pipe(first())
                  .toPromise()
                  .then(() =>
                    this.branch.goToNextPage(CONSTANTS.surveyTypes.SIGNUP, 'start', this.utils.subset(res, ['id', 'lastPage', 'path']))
                  );
              }
            });
        } else {
          // Need to have hhRecipe before this
          this.logger.error('hhRecipe N/A', MSRemoteLoggerCategory.REGISTRATION_SERVICE);
        }
        // TODO - confirm this is true
        // if signup survey, personId gets sent from server after uploading signup survey (persons-setup page)
        // if not signup survey, we auto set personId if 1 participant, otherwise we need to ask
      } else if (!personId) {
        return this.persons.getParticipants().then((participants) => {
          // if we're in the browser, don't ask who the current user is. just default to the first person
          if (participants.length === 1) {
            return this.setData({ personId: participants[0].idx });
          } else {
            // return { page: 'person', params: {} };
            return ['/person'];
          }
        });
      } else {
        // return this.refreshSurveys(authCode, locale, personId)
        return this.setProxiedCount().then(() => this.afterActivated());
      }
    });
  }

  setProxiedCount() {
    return Promise.all([this.persons.getDeviceOwner(), this.persons.getSurveyableNonParticipants()]).then((res) => {
      // if proxying, store the number of surveyable non-participants, else, 0
      const count = res[0].is_proxy === true ? res[1].length : 0;
      return this.prefs.getStorePromise('proxiedCount', count);
    });
  }

  async setData(data): Promise<[string]> {
    await this.setDataWithoutGoToNextPage(data);
    const nextPage = (await this.goToNextPage()) as [string];

    return nextPage;
  }

  async setDataWithoutGoToNextPage(data): Promise<void> {
    const promises = [];
    let locale = null;
    const save = (k, v) => {
      if (v !== undefined) {
        // the transit data does not fit in one field so we chop it up to separate fields
        if (k == CONSTANTS.PREF_KEY_TRANSIT_STOPS) {
          let i = 0;
          const keys = [];
          for (const a of v.agencies) {
            i = i + 1;
            const key = k + i;
            keys.push(key);
            promises.push(this.prefs.getStorePromise(key, a));
          }
          const agencyKeyList = { agencies: keys };
          promises.push(this.prefs.getStorePromise(k, agencyKeyList));
        } else {
          promises.push(this.prefs.getStorePromise(k, v));
        }
        //               promises.push(this.prefs.getStorePromise(k, v));
      }
    };
    const stringKeys = {
      // from server              : for client
      appVersion: 'appVersion', // passed from auth page
      // 'translations'           : 'translations',                               // from server after authorize
      study_id: 'studyId', // from server after authorize
      household_id: 'personsId', // from server after authorize I think
      //'authCode'                : 'authCode',                                   // no need to save, might be generic, and authorize call returns household_authcode
      household_authcode: 'authCode', // if using study authcode, we get a household authcode after signup survey
      num_vehicles: 'numVehicles', // from server after set_locale
      has_pets: 'hasPets', // from server after set_locale
      personId: 'personId', // this comes from person page
      person_id: 'personId', // this comes from server if a) 1 person hh ?? (TODO - check this) or b) signup survey
      termsAccepted: 'termsAccepted',
      abortMessageKey: 'abortMessageKey',
      activation_code: 'activationCode', // from server after activate
      surveys: CONSTANTS.PREF_KEY_SURVEY_RECIPES, // from server after activate
      signup_survey_recipe: CONSTANTS.PREF_KEY_SIGNUP_SURVEY_RECIPE, // from server after activate
      automobile_types: CONSTANTS.PREF_KEY_AUTOMOBILE_TYPES, // from server after activate
      transit_stops: CONSTANTS.PREF_KEY_TRANSIT_STOPS, // from server after activate
      signup_survey_responses: CONSTANTS.PREF_KEY_SIGNUP_SURVEY_RESPONSES, // from server after activate
      phases: 'phases', // from server after activate
      browser: 'browser', // from server after activate
      //'extra'                   : 'stopsCsv',                                   // from server after activate, 'extra' is prob temp
      app_title: 'appTitle' // from server after authorize
    };
    const intKeys = {
      study_type: 'studyType', // from server after auth
      study_expiration_days: 'studyExpirationDays', // not being passed from server yet, but could be in the future. default is set on constants
      start_date: 'startDate', // from server after activate
      stop_date: 'stopDate', // from server after activate
      default_map_center_lat: 'defaultMapLat', // from server after authorize
      default_map_center_lon: 'defaultMapLon', // from server after authorize
      default_map_radius_m: 'defaultMapRadiusMeters' // from server after authorize
    };

    if (data.default_map_center_lat && data.default_map_center_lon) {
      CONSTANTS.MAPS.DEFAULT_MAP_CENTER = {
        lat: this.gis.getFloatLatOrLon(data.default_map_center_lat),
        lng: this.gis.getFloatLatOrLon(data.default_map_center_lon)
      };
    }

    // TODO - server needs to figure out participation
    if (data.persons && data.browser && data.browser == 1) {
      data.persons.forEach((p) => {
        if (p.age === 1) {
          p.participant = false;
        }
      });
    }

    if (data.persons) {
      data.persons.forEach((p) => {
        p.trips_complete = 0;
      });
    }

    if (data.app_title) {
      this.title.setTitle(data.app_title);
    }

    // other keys
    // uri - from server after auth
    // locales - from server after auth
    // persons - from server after locales if not signup.

    Object.keys(stringKeys).forEach((key) => save(stringKeys[key], data[key]));
    //TODO - is this in conversion necessary?
    Object.keys(intKeys).forEach((key) => {
      const i = parseInt(data[key], 10);
      if (!isNaN(i)) {
        save(intKeys[key], i);
      }
    });

    /**
     * We set the server url in config.ts during the build process. This tells us which server to hit when first authorizing.
     * We can then be redirected to a different server, so we store the server url in prefs and use that going forward.
     * The server always expects /en attached to the url, regardless of the user-selected locale
     * The exception is the hh complete dashboard, which needs to insert the correct locale in the url string
     */

    if (data.locale) {
      locale = data.locale;
      save('locale', locale);
      await this.userStorageUseCase.setLocale(locale).pipe(
        first()
      ).toPromise();
    }

    if (data.locales) {
      promises.push(this.prefs.getStorePromise('locales', data.locales));
      if (!locale && data.locales.length === 1) {
        locale = data.locales[0].code;
        save('locale', locale);
        await this.userStorageUseCase.setLocale(locale).pipe(
          first()
        ).toPromise();
      }
    }

    if (data.persons && data.persons.length > 0) {
      promises.push(this.persons.populate(data));
    }

    return Promise.all(promises)
      .then(() => {
        // if only 1 locale in the study, we have both locale and translations after authorizing
        if (locale) {
          this.logger.log('Found locale in registration data. Setting locale and translations.', MSRemoteLoggerCategory.REGISTRATION_SERVICE);
          return this.translationUseCase.setLanguage(locale)
            .pipe(first())
            .toPromise();
          // if 2+ locales, we get translations first, then get locale
        } else {
          return Promise.resolve(null);
        }
      })
      .catch((err) => this.logger.error('Error in registration promise chain', MSRemoteLoggerCategory.REGISTRATION_SERVICE, err));
  }

  //Why is this named authenticate? What is it authenticating?
  async authenticate(data) {
    await this.sqlHelper.initialize(data.household_authcode)
    await this.prefs.initialize(data.household_authcode, data.uri);
    await this.setDataWithoutGoToNextPage(data);
    await this.initializer.initCrashReporting();
  }

  selectLocale = this.setData;
  acceptTerms = this.setData;
  selectPerson = this.setData;
  setPersons = this.setData;

  async initialize(): Promise<string[]> {
    this.logger.log('Registration service - running initialize', MSRemoteLoggerCategory.REGISTRATION_SERVICE);

    //I tried to extract this code into its own function, but it didn't work. I'm not sure why.
    if (CONSTANTS.IS_DEVICE) {
      await this.platform.ready();
      const appVersion = await App.getInfo().then((appInfo: AppInfo) => appInfo.version);
      await this.prefs.getStorePromise('appVersion', appVersion);
    } else {
      const params = await this.prefs.getAuthParams();
      if (params) {
        await this.sqlHelper.initialize(params['household_authcode']);
      }
    }


    await this.prefs._constructed;
    await this.userStorageUseCase.migrateIfNeeded().toPromise();
    await this.setupTranslations().toPromise();

    //Ensure this and the next function are called before any calls to storage are made
    await this.migrateServerAddressUseCase
      .execute()
      .pipe(first())
      .toPromise();

    await this.userStorageUseCase
      .getServerAddress()
      .pipe(
        tap((url) => this.apiServiceOld.updateUrl(url))
      ).toPromise();

    const authCode = await this.prefs
      .getPromiseOfTypeOrDefault('authCode', null)

    if (authCode) {
      this.remoteLoggerUseCase.setUserProperty({ authCode: authCode });
      //Sets Config and Feature Flags for later use
      await configExecuteAsPromise(authCode, this.configUseCase);

      const checkVersionStatus = await checkVersionExecuteAsPromise(this.checkVersionUseCase).catch(() => new CheckVersionEvent.Unknown());

      if (checkVersionStatus instanceof CheckVersionEvent.UpdateRequired) {
        CONSTANTS.registrationInitialized = true;
        return [`/${CheckVersionPageModule.route.path}`];
      }
    }

    CONSTANTS.registrationInitialized = true;
    const nextPageRef = (await this.goToNextPage()) as string[];
    return nextPageRef;
  }

  reregister() {
    // TODO - is this all if we're not doing re-reg anymore?
    return this.prefs.clearPrefs();
  }
  private setupTranslations(): Observable<void> {
    const setDefaultLanguageObs = this.translationUseCase.setDefaultLanguage(CONSTANTS.translations.defaultLang)
    const setLanguageObs = this.userStorageUseCase.getLocale().pipe(
      switchMap((locale) => {
        if (!locale) {
          return this.translationUseCase.getBrowserLanguage();
        } else {
          return of(locale);
        }
      }),
      switchMap((locale) => this.translationUseCase.setLanguage(locale)),
    );

    const setupObs = forkJoin([
      setDefaultLanguageObs,
      setLanguageObs
    ]).pipe(
      map((_) => undefined)
    )

    return setupObs;
  }}
